export type FlashMessageType = 'success' | 'warn' | 'error';
export const getFlashMessageType = (code: number): FlashMessageType | null => {
  if (code >= 200 && code < 300) return 'success';
  if (code >= 400 && code < 500) return 'warn';
  if (code >= 500 && code < 600) return 'error';
  return null;
};
